import { render, staticRenderFns } from "./BedRearrangement.vue?vue&type=template&id=5ea50874&scoped=true"
import script from "./BedRearrangement.vue?vue&type=script&lang=js"
export * from "./BedRearrangement.vue?vue&type=script&lang=js"
import style0 from "./BedRearrangement.vue?vue&type=style&index=0&id=5ea50874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea50874",
  null
  
)

export default component.exports